import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const sections = document.querySelectorAll( ".why-choose-afton" );

sections.forEach( ( section ) => {
  const slider = tns( {
    container: section.querySelector( ".slider" ),
    items: 1,
    center: true,
    autoplay: false,
    controls: true,
    nav: false,
    navContainer: section.querySelector( ".slider-nav" ),
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 400,
    gutter: 200,
    fixedHeight: true,
    fixedWidth: 300,
    startIndex: 0,
    responsive: {
      768: {
        fixedWidth: 320,
        gutter: 30,
      },
      1024: {
        fixedWidth: 340,
        gutter: 40,
      },
      1280: {
        fixedWidth: 340,
        gutter: 60,
      },
    },
  } );

  const svgLine = section.querySelector( ".afton-line" );

  slider.events.on( "transitionStart", function ( info ) {
    const activeIndex = info.index;

    section.querySelectorAll( ".slider-nav li" ).forEach( ( item, index ) => {
      item.classList.toggle( "active", index === activeIndex );
    } );

    // Move the SVG line on desktop
    if ( window.innerWidth >= 1024 && svgLine ) {
      const moveAmount = activeIndex * 400; // 340px slide + 60px gutter

      gsap.set( svgLine, {
        x: -moveAmount,
        duration: 0,
      } );
    }
  } );



  // Nav click events
  section.querySelectorAll( ".slider-nav li" ).forEach( ( item, index ) => {
    item.addEventListener( "click", () => {
      slider.goTo( index );
    } );
  } );
} );
